import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    CircularProgress,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
    Container
} from "@mui/material";
import { rchAPI } from "../../services/rch.api";
import Loader from "../../components/Loader";

const RchBeneficiaries = () => {
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [beneficiariesList, setBeneficiariesList] = useState([]);

    const userMobile = localStorage.getItem("janani_username");

    useEffect(() => {
        fetchRchBeneficiaries();
    }, [userMobile]);

    const fetchRchBeneficiaries = async () => {
        try {
            setIsPageLoading(true);
            const response = await rchAPI.listRchBeneficiaries({ mobile: userMobile });
            const apiRes = response?.data?.data;

            if (apiRes?.success) {
                setBeneficiariesList(apiRes?.data);
            }
        } catch (error) {
            console.error("Error fetching RCH beneficiaries:", error);
            return [];
        } finally {
            setIsPageLoading(false);
        }
    };

    return (
        <>
            {isPageLoading && <Loader />}

            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    {/* Header */}
                    <h4 className="mb-3">
                        <span>
                            <img
                                src={"/images/Rchicon.svg"}
                                alt=""
                                style={{ width: "50px", marginRight: "15px" }}
                            />
                        </span>
                        JANANI Beneficiaries List
                    </h4>


                    {/* Table */}
                    <TableContainer
                        sx={{
                            borderRadius: 2,
                            border: "1px solid #e0e0e0",
                            // maxHeight: 420
                        }}
                    >
                        <Table
                            stickyHeader
                            sx={{
                                "& th, & td": {
                                    borderRight: "none"
                                }
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    {["Name", "Beneficiary Gender","Beneficiary Type", "ABHA Number", "Mobile Number", "HRP" ].map((head) => (
                                        <TableCell
                                            key={head}
                                            sx={{
                                                fontWeight: 600,
                                                backgroundColor: "#f5f7fa"
                                            }}
                                        >
                                            {head}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>

                                {/* Data */}
                                {beneficiariesList.length > 0 ?
                                    beneficiariesList.map((row, index) => (
                                        <TableRow
                                            key={row.benef_id}
                                            hover
                                            sx={{
                                                backgroundColor:
                                                    index % 2 === 0 ? "#fafafa" : "#ffffff"
                                            }}
                                        >
                                            <TableCell sx={{ fontWeight: 500, textTransform: "capitalize" }}>
                                                {row.benf_name}
                                            </TableCell>
                                            <TableCell>{row.gender_name}</TableCell>
                                            <TableCell>{row.benf_type_name}</TableCell>
                                            <TableCell>{row.abha_id || "-"}</TableCell>
                                            <TableCell>{row.mobile || "-"}</TableCell>
                                            <TableCell>
                                                {/* <Chip
                                                    variant="outlined"
                                                    label={row.is_hrp ? "Yes" : "-"}
                                                    size="small"
                                                    color={row.is_hrp ? "success" : ""}
                                                /> */}
                                                {row.is_hrp ? "Yes" : "-"}
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">
                                                No beneficiaries found.
                                            </TableCell>
                                        </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        </>
    );
};

export default RchBeneficiaries;